
export function regexChecker (value: string): boolean {
  const regexValidator = /^[.+\-()\w\s]+$/
  const checkResult: RegExpExecArray | null = regexValidator.exec(value)
  if (checkResult != null) {
    return true
  }
  return false
}

// export function validateParametersData (parameters: parametersData[]): boolean {
//   for (const parameter of parameters) {
//     if (parameter.parameterName === '') return false
//     else if ((parameter.value === '') && parameter.sampleValue !== null) return false
//     else if ((parameter.value !== '' && parameter.parameterName.toUpperCase().includes('IP') && isValidIp(parameter.value))) {
//       const ipaddr = parameter.value.split('.')
//       for (const section of ipaddr) {
//         if (section.length >= 2 && section[0] === '0') return false
//       }
//     } else if ((parameter.value !== '' && parameter.parameterName.toUpperCase().includes('IP') && !isValidIp(parameter.value))) return false
//     else if ((parameter.value !== '' && parameter.parameterName.toUpperCase().includes('PORT') && !isValidPort(parameter.value))) return false
//     else if ((parameter.value !== '' && !regexChecker(parameter.value))) return false
//   }
//   return true
// }

export function isValidName (value: string): boolean {
  const regexValidator = /^[a-zA-Z0-9_]+(\.[a-zA-Z0-9_]+)?$/
  return regexValidator.test(value)
}

export function isValidVersionCharacter (value: string): boolean {
  const regexValidator1 = /^\d{1,3}$/
  const regexValidator = /^\d{1,3}\.$/
  const regexValidatorTwoDigit1 = /^\d{1,3}\.\d{1,3}$/
  const regexValidatorTwoDigit = /^\d{1,3}\.\d{1,3}\.$/
  const versionRegex = /^\d{1,3}\.\d{1,3}\.\d{1,3}$/
  return (regexValidator.test(value) || versionRegex.test(value) || regexValidatorTwoDigit.test(value) || regexValidator1.test(value) || regexValidatorTwoDigit1.test(value))
}

export function isValidVersion (value: string): boolean {
  if (value === '' || value === null) {
    return true
  }
  const regexValidator = /^\d{1,3}\.\d{1,3}\.\d{1,3}$/
  return regexValidator.test(value)
}

export function isValidIp (value: string): boolean {
  const ipAddressRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
  return ipAddressRegex.test(value)
}

export function isValidPort (port: string): boolean {
  if (!/^\d+$/.test(port)) {
    return false
  }
  const portNumber = parseInt(port, 10)
  return !isNaN(portNumber) && portNumber >= 1 && portNumber <= 65535
}

export function isValidText (value: string): boolean {
  const regexValidator = /^[a-zA-Z0-9]+(\s?[a-zA-Z0-9]+)*(\.[a-zA-Z0-9]+(\s?[a-zA-Z0-9]+)?)?$/
  return regexValidator.test(value?.trim())
}

export function isValidThermalAsset (value: string): boolean {
  const regexValidator = /^[a-zA-Z0-9_-]+(\s?[a-zA-Z0-9_-]+)*(\.[a-zA-Z0-9_-]+(\s?[a-zA-Z0-9_-]+)?)?$/ // Allow alphaNumeric, space, _, -
  return regexValidator.test(value?.trim())
}

export function isValidGroupName (value: string): boolean {
  const regexValidator = /^[a-zA-Z0-9_]+$/ // Allow alphabets, numbers, and underscores
  return regexValidator.test(value)
}

export function isValidLatLong (value: string): boolean {
  const regexValidator = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/
  return regexValidator.test(value)
}

export function isValidSlaveAddress (value: string): boolean {
  const regexValidator = /^(?:[1-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/
  return regexValidator.test(value)
}

export function isValidSiteData (value: string): boolean {
  const regexValidator = /^[a-zA-Z0-9]+([ \-_][a-zA-Z0-9]+)*$/
  return regexValidator.test(value)
}
export function isValidAssetData (value: string): boolean {
  const regexValidator = /^[a-zA-Z0-9]+([ \-_][a-zA-Z0-9]+)*$/
  return regexValidator.test(value)
}

export function isValidApplicationType (value: string): boolean {
  const regexValidator = /^[a-zA-Z0-9_]+([ -][a-zA-Z0-9_]+)*$/
  return regexValidator.test(value)
}

export function isValidDeviceType (value: string): boolean {
  const regexValidator = /^[a-zA-Z0-9_]+([ -][a-zA-Z0-9_]+)*$/
  return regexValidator.test(value)
}

export function inValidEndOfString (value: string): boolean { // If string end with space, _, -
  const regexValidator = /[\s-_]$/
  return regexValidator.test(value)
}
export function inValidStartOfString (value: string): boolean { // If string start with space, _, -
  const regexValidator = /^[\s-_]/
  return regexValidator.test(value)
}

export function isValidGatewayData (value: string): boolean {
  const regexValidator = /^[a-zA-Z0-9]+([ \-_][a-zA-Z0-9]+)*$/
  return regexValidator.test(value)
}
export function isValidGatewayDesc (value: string): boolean { // Allow only alphabets, numbers with space between strings
  const regexValidator = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)*$/
  return regexValidator.test(value)
}
export function isValidGatewayPort (port: string): boolean {
  if (!/^\d+$/.test(port)) {
    return false
  }
  const portNumber = parseInt(port, 10)
  return !isNaN(portNumber) && portNumber >= 1 && portNumber <= 65535
}

export function hasSpaceAtStartOrEnd (value: string): boolean { // If string start or end with space
  const regexValidator = /^[\s]+|[\s]+$/
  return regexValidator.test(value)
}
export function hasSpecialCharAtStartOrEnd (value: string): boolean {
  const regexValidator = /^[\s\-_]+|[\s\-_]+$/
  return regexValidator.test(value)
}
export function isValidDeviceData (value: string): boolean {
  const regexValidator = /^[a-zA-Z0-9]+([ \-_][a-zA-Z0-9]+)*$/
  return regexValidator.test(value)
}
export function isValidDevicePort (port: string): boolean {
  if (!/^\d+$/.test(port)) {
    return false
  }
  const portNumber = parseInt(port, 10)
  return !isNaN(portNumber) && portNumber >= 1 && portNumber <= 65535
}
export function isValidKpiData (value: string): boolean {
  const regexValidator = /^[a-zA-Z0-9]+([ \-_][a-zA-Z0-9]+)*$/
  return regexValidator.test(value)
}

export function isValidInputData (value: string): boolean {
  const regexValidator = /^[a-zA-Z0-9]+([ \-_][a-zA-Z0-9]+)*$/
  return regexValidator.test(value)
}

/**
 * Sanitizes input by preventing leading spaces and limiting character length
 * @param value - The input value to sanitize
 * @param maxLength - Maximum allowed length (default: 30)
 * @returns Sanitized input value
 */
export function sanitizeInput (value: string, maxLength = 30): string {
  let sanitizedValue = value
  // Prevent leading spaces
  if (sanitizedValue.startsWith(' ')) {
    sanitizedValue = sanitizedValue.trimStart()
  }
  // Limit to specified character length
  if (sanitizedValue.length > maxLength) {
    sanitizedValue = sanitizedValue.substring(0, maxLength)
  }
  return sanitizedValue
}
